import axios from '@/utils/request'
import base from '../base'


export function menuList() {
  return axios.get(`${base.url}/auth/menus/list`);
}
export function editMenuList(data) {
  return axios.post(`${base.url}/auth/menus/edit`, JSON.stringify(data),{ headers: {'Content-Type': 'application/json'}});
}
export function addMenuList(data) {
  return axios.post(`${base.url}/auth/menus/save`, JSON.stringify(data),{ headers: {'Content-Type': 'application/json'}});
}
export function delMenuList(id) {
  return axios.get(`${base.url}/auth/menus/del?id=${id}`);
}

